module.exports = __webpack_public_path__ + "assets/img/116f855ed7a39448f242f9ec07e8091e.png";